/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Update_Horizontal_LabelInputs */

const en_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Horizontal`)
};

const fr_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour l'horizontal`)
};

const de_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontal aktualisieren`)
};

const it_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna orizzontale`)
};

const ru_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить горизонтальный`)
};

const es_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización horizontal`)
};

const zh_cn2_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新水平`)
};

const ja_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平方向の更新`)
};

const hi_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षैतिज अपडेट करें`)
};

const pt_pt2_position_modal_update_horizontal_label = /** @type {(inputs: Position_Modal_Update_Horizontal_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização horizontal`)
};

/**
* | output |
* | --- |
* | "Update Horizontal" |
*
* @param {Position_Modal_Update_Horizontal_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_update_horizontal_label = /** @type {((inputs?: Position_Modal_Update_Horizontal_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Update_Horizontal_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_update_horizontal_label(inputs)
	if (locale === "de") return de_position_modal_update_horizontal_label(inputs)
	if (locale === "it") return it_position_modal_update_horizontal_label(inputs)
	if (locale === "ru") return ru_position_modal_update_horizontal_label(inputs)
	if (locale === "es") return es_position_modal_update_horizontal_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_update_horizontal_label(inputs)
	if (locale === "ja") return ja_position_modal_update_horizontal_label(inputs)
	if (locale === "hi") return hi_position_modal_update_horizontal_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_update_horizontal_label(inputs)
	return en_position_modal_update_horizontal_label(inputs)
});